export enum CommunityEventResponseStatusId {
    APPROVED = 1,
    REJECTED = 2,
    PENDING = 4
}

export interface CommunityEventSummary {
    id: number;
    statusId: CommunityEventResponseStatusId;
    startDateTime: string;
    endDateTime: string;
    description: string;
    title: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    location: string;
}

export interface CommunityScheduledEvent extends CommunityEventSummary {
    startTime: string;
}

export interface CommunityScheduledDay {
    dayTitle: string;
    events: CommunityScheduledEvent[];
}

export interface CommunityScheduledWeek {
    weekTitle: string;
    eventsByDay: CommunityScheduledDay[];
}
